import * as React from "react"
import _ from "lodash"
import en from "../../../i18n/en"
import { Appearance, ViewStyle } from "react-native"
import { FastField } from "formik"
import { FormControl, FormControlProps } from "../../form-control/form-control"
import { MultipleImageInput, MultipleImageInputProps } from "../../input/multiple-image-input/multiple-image-input"
import { TxKeyPath } from "../../../i18n"
import { color } from "../../../theme"
import { observer } from "mobx-react-lite"

export interface MultipleImageFieldProps {
  FieldComponent?: React.ComponentType<any>,
  name: string,
  colorScheme?: "light" | "dark",
  txPrefix?: keyof typeof en,
  input?: any,
  nextInput?: any,
  formControlProps?: FormControlProps,
  multipleImageProps?: MultipleImageInputProps
}

const FORM_CONTROL: ViewStyle = {
  marginBottom: 8
}

const FORM_CONTROL_LABEL: ViewStyle = {
  paddingLeft: 16
}

/**
 * Describe your component here
 */
export const MultipleImageField = observer(function MultipleImageField(props: MultipleImageFieldProps) {
  const {
    FieldComponent = FastField,
    name, colorScheme = "light" || Appearance.getColorScheme(),
    txPrefix,
    formControlProps, multipleImageProps: { flatListProps, ...multipleImageProps } = {}
  } = props
  const column = name.split('.').pop()

  return (
    <FieldComponent name={name}>
      {({ field, form: { setFieldValue, setFieldTouched }, meta }) => (
        <FormControl
          isInvalid={(meta.initialValue || meta.touched) && !!meta.error}
          labelTx={(txPrefix && `${txPrefix}.${_.camelCase(column)}` as TxKeyPath) || undefined}
          colorScheme={colorScheme}
          labelColor={color.palette.gray800}
          errorMessage={meta.error}
          style={FORM_CONTROL}
          labelStyle={FORM_CONTROL_LABEL}
          {...formControlProps}
        >
          <MultipleImageInput
            colorScheme={colorScheme}
            values={field.value}
            onItemChanged={async (value, index) => {
              await setFieldValue(`${field.name}.${index}`, value)
              await setFieldTouched(field.name)
            }}
            flatListProps={{
              contentContainerStyle: { paddingHorizontal: 16 },
              ...flatListProps
            }}
            {...multipleImageProps}
          />
        </FormControl>
      )}
    </FieldComponent>
  )
})
